import type {Recipe} from './types';

export const budinoAllaVanigliaConMaizena: Recipe = {
    id: 0,
    key: "budinoAllaVanigliaConMaizena",
    pictures: [
        {index: 0, url: "https://www.giallozafferano.it/images/6-626/Budino-alla-vaniglia_450x300.jpg"},
    ],
    i18n: {
        IT: {
            title: "Budino alla vaniglia con maizena",
            servings: "Ingredienti per 6 stampini",
            ingredients: [
                "500 ml di latte",
                "2 uova",
                "100 gr di zucchero",
                "1 stecca di vaniglia",
                "3 cucchiai di maizena",
            ],
            steps: [
                "Incidete una stecca di vaniglia e fatela sobollire nel latte per 5 minuti, così che sprigioni tutto il suo aroma.",
                "In una ciotola montate le uova con lo zucchero.",
                "Aggiungete la maizena e formate una crema.",
                "Filtrate il latte, aggiungetelo alla crema di uova e mescolate.",
                "Rimettete sul fuoco e fate addensare.",
                "Versate il composto ottenuto negli stampini e mettete in frigo per 3 ore.",
                "Capovolgete il budino alla vaniglia nei piattini e servite.",
            ],
            notes: "Per un tocco in più, servire con frutti di bosco freschi o una colata di salsa al cioccolato.",
        },
        EN: {
            title: "Vanilla Pudding with Cornstarch",
            servings: "Ingredients for 6 molds",
            ingredients: [
                "500 ml of milk",
                "2 eggs ",
                "100 gr of sugar ",
                "1 vanilla pod ",
                "3 tablespoons of cornstarch",
            ],
            steps: [
                "Slit a vanilla pod and let it simmer in milk for 5 minutes, so that it releases all its aroma.",
                "In a bowl, beat the eggs with the sugar.",
                "Add the cornstarch and form a cream.",
                "Strain the milk, add it to the egg cream, and mix.",
                "Put it back on the heat and let it thicken.",
                "Pour the mixture into molds and refrigerate for 3 hours.",
                "Turn the vanilla pudding onto small plates and serve.",
            ],
            notes: "For an extra touch, serve with fresh berries or a drizzle of chocolate sauce.",
        },
        PL: {
            title: "Budyń waniliowy ze skrobią kukurydzianą",
            servings: "Składniki na 6 foremek",
            ingredients: [
                "500 ml mleka",
                "2 jajka ",
                "100 g cukru ",
                "1 laska wanilii ",
                "3 łyżki skrobi kukurydzianej",
            ],
            steps: [
                "Rozetnij laskę wanilii i gotuj ją na wolnym ogniu w mleku przez 5 minut, aby uwolniła cały swój aromat.",
                "W misce ubij jajka z cukrem.",
                "Dodaj skrobię kukurydzianą i uformuj krem.",
                "Przecedź mleko, dodaj je do kremu jajecznego i wymieszaj.",
                "Ponownie podgrzej na ogniu i gotuj, aż zgęstnieje.",
                "Wlej mieszankę do foremek i schładzaj w lodówce przez 3 godziny.",
                "Odwróć waniliowy budyń na talerzyki i podawaj.",
            ],
            notes: "Dla dodatkowego akcentu podawać z świeżymi owocami leśnymi lub polewą czekoladową.",
        },
    },
};
